
import AppSaleEdit from "@/components/sales/SaleEdit.vue";
import { Sale, SaleExtraFields } from "@/models/base";
import { SaleService } from "@/services/sale-service";
import { ToolbarService } from "@/services/toolbar-service";
import { PendingChangesNotifier } from "@/utils/pending-changes-notifier";
import Vue from "vue";
import { TranslateResult } from "vue-i18n";
import { SaleEditState } from "@/utils/sale-edit/sale-edit-state";
import { DossierConfigService } from "@/services/dossier-config-service";
import { ConfirmResult } from "winfakt-vue-components";
import {AuthService, BookYearService, UserConfigService} from "@/services";
import {CashierService} from "@/services/cashier-service";
import router from "@/router";
import { InboxreaderService } from "@/services/inboxreader-service";
import {processSelfBilledSale} from "@/utils/peppol/self-billing";
import { MODULE } from "@/config/modules";

export default Vue.extend({
	data() {
		let warningText = () => {
			return "test";
		};
		return {
			sale: new Sale(),
			state: null as null | SaleEditState,
			pendingChangesNotifier: new PendingChangesNotifier(this, "saleString", {warningText}),
			ready: false
		};
	},
	props: {
		saleId: Number
	},
	computed: {
		saleString():string {
			return JSON.stringify(this.sale.getJSON());
		},
		title():TranslateResult{
			return ToolbarService.title;
		},
		pendingChangesWarningText(): string{
			return this.$ct("save-confirm",{type: this.saleName, id: this.sale.ComputedFriendlyID}).toString();
		},
		saleName(): string {
			return this.sale.Type.Name.getTranslation(this.sale.getLng()).toLowerCase();
		},
		inboxreaderId():number{
			if (!this.$route.params.inboxreaderId) return 0;
			return parseInt(this.$route.params.inboxreaderId || "0");
		}
	},
	methods: {
		async close(){
			let crmID = parseInt((this.$route.query.crmId as string));
			if(crmID>0){
				await router.push(`/crm/edit/${this.sale.CrmID}`);
				return;
			}
			await this.$router.push("/sales");
		},
		async onSaved(sale:Sale) {
			let settings = UserConfigService.getSaleSettings();
			if (settings.ClearSelectionAfterSave) {
				this.$emit("clear-selection");
			}
			this.sale = sale;
			await this.$nextTick();
			this.pendingChangesNotifier.changesPending = false;
			if (this.inboxreaderId) {
				await InboxreaderService.archiveInboxreaderPurchase(this.inboxreaderId);
			}
		},
	},
	/* eslint-disable-next-line max-lines-per-function */
	async mounted() {
		let saleTypeId = parseInt((this.$route.query.typeId as string) || "1") || 1;
		let contactID = parseInt((this.$route.query.contactId as string));
		let crmID = parseInt((this.$route.query.crmId as string));
		let allSaleTypes = SaleService.getTypes(1);
		let saleType = allSaleTypes.find(s=>s.ID == saleTypeId);
		if (saleType){
			this.sale.Type = saleType;
			this.sale.TypeID = saleType.ID;
		}else{
			this.sale.Type = allSaleTypes[0];
			this.sale.TypeID = allSaleTypes[0].ID;
		}
		if(crmID){
			this.sale.CrmID = crmID;
		}
		let id = parseInt(this.$route.params.id || "0");
		if (this.saleId) {
			id = this.saleId;
		}
		if (id) {
			this.sale = await SaleService.getSale(id);

			//duplicate?
			if(this.$route.path.includes("duplicate")){
				this.sale = this.sale.duplicate();
				this.sale.calculateTotals();
			}

			await this.$nextTick();
			this.pendingChangesNotifier.changesPending = false;
		}else if (this.inboxreaderId){
			if (!AuthService.hasModule(MODULE.SELF_BILLING)){
				return this.$router.push("/missing-module/" + MODULE.SELF_BILLING);
			}
			let result = await SaleService.fromInboxReader(this.inboxreaderId);
			let confirm = await processSelfBilledSale(result);
			if (confirm == ConfirmResult.CANCEL) {
				this.$router.push("/inbox");
			}
			this.sale = result.Sale;
			await this.$nextTick();
		}else{
			if (!this.sale.ExtraFields){
				this.sale.ExtraFields = new SaleExtraFields();
			}
			DossierConfigService.getExtraFieldNamesConfigs().SaleNames.setDefaultValues(this.sale.ExtraFields);
			if (this.$route.query.fromJson){
				this.sale = new Sale(JSON.parse(this.$route.query.fromJson as string));
				this.sale.ID = 0;
			}
		}

		if(contactID){
			this.sale.ContactID = contactID;
		}

		//clear display
		let c = await UserConfigService.getCashierSettings();
		if(c.ConnectedDisplay!=""){
			await CashierService.clearDisplay(c.ConnectedDisplay);
		}

		this.pendingChangesNotifier = new PendingChangesNotifier(this, "saleString", {warningText: ()=>this.pendingChangesWarningText});

		let supposedBookyear = BookYearService.getBookYearFromDate(this.sale.InvoiceDate);
		if (supposedBookyear != BookYearService.selectedBookYear && this.sale.ID == 0) {
			let confirm = await (this.$confirmBuilder(this.$ct("components.sales.confirm-wrong-bookyear")).setWarningTitle().show());
			if (!confirm){
				this.pendingChangesNotifier.changesPending = false;
				await this.$router.push("/sales");
				return;
			}
		}

		this.ready = true;
	},
	components: {
		AppSaleEdit
	},
	i18nEx: {
		componentPrefix: "components.sales"
	},
	async beforeRouteLeave(to, from, next) {
		let result = await this.pendingChangesNotifier.askToSave();
		if (result == ConfirmResult.CANCEL){
			return;
		}
		if (result == ConfirmResult.YES) {
			if(this.state && this.pendingChangesNotifier.changesPending){
				if (!this.sale.ContactID) {
					this.$wf.notify(this.$ct("error-contact-empty").toString(), "danger", 3500, "exclamation-triangle");
					return false;
				}
				this.state.openSaveModal();
				return;
			}
		}
		this.$emit("parent-should-refresh");
		next();
	}
});
